(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/game-guide-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/game-guide-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiterHelper;
let trinidad;
if (isServer) {
  const path = require('path');
  trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiterHelper = require(path.join(__dirname, 'jupiter-helper.es6'));
  logger = trinidad.logger('arena: game-guide-service');
} else {
  trinidad = svs.core;
  jupiterHelper = svs.arena.service.jupiterHelper;
  logger = svs.arena.logger;
}


const getCmsDataFolderAsync = async parentId => {
  if (!isServer) {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-tb');
    if (!useLegacyJupiterApi) {
      try {
        const client = svs.content.shared.getCmsClient();
        const data = await client.v1.content.filter({
          parentIds: parentId,
          count: 20,
          sort: ['rank;desc']
        });
        return {
          data: data || [],
          error: null
        };
      } catch (err) {
        logger.info('Error getting CMS data folder (CMS API)', err);
        return {
          data: [],
          error: err
        };
      }
    }
  }
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
      parentId,
      count: 20,
      sortOrder: 'desc'
    }).build()
  };
  logger.debug('Call to getCmsDataFolderAsync with options: ', options);
  const _await$jupiterHelper$ = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$.data,
    error = _await$jupiterHelper$.error;
  logger.debug('Call to getCmsDataFolderAsync response data, error: ', data, error);
  return {
    data: data || [],
    error
  };
};

const getCmsDataDocumentAsync = async id => {
  if (!isServer) {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-tb');
    if (!useLegacyJupiterApi) {
      try {
        const client = svs.content.shared.getCmsClient();
        const data = await client.v1.content.getByIds({
          ids: String(id)
        });
        return {
          data: (data === null || data === void 0 ? void 0 : data.result) || [],
          error: null
        };
      } catch (err) {
        logger.info('Error getting CMS Data Document Async (CMS API)', err);
        return {
          data: [],
          error: err
        };
      }
    }
  }
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('id').addParams({
      ids: [id],
      count: 100
    }).build()
  };
  logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
  const _await$jupiterHelper$2 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$2.data,
    error = _await$jupiterHelper$2.error;
  return {
    data: data || [],
    error
  };
};

const getCmsDataDocumentsAsync = async idList => {
  if (!isServer) {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-tb');
    if (!useLegacyJupiterApi) {
      try {
        const client = svs.content.shared.getCmsClient();
        const data = await client.v1.content.getByIds({
          ids: idList.join(',')
        });
        return {
          data: (data === null || data === void 0 ? void 0 : data.result) || [],
          error: null
        };
      } catch (err) {
        logger.info('Error getting CMS Data Documents Async (CMS API)', err);
        return {
          data: [],
          error: err
        };
      }
    }
  }
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('id').addParams({
      ids: idList,
      count: 100
    }).build()
  };
  logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
  const _await$jupiterHelper$3 = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$3.data,
    error = _await$jupiterHelper$3.error;
  return {
    data: data || [],
    error
  };
};
const exportedFunctions = {
  getCmsDataFolderAsync,
  getCmsDataDocumentAsync,
  getCmsDataDocumentsAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.gameGuideService = exportedFunctions;
}

 })(window);